import { Injectable } from '@angular/core';
import { TaskDescriptionAcknowledgement } from '@app/shared/types/models/task/task-description-acknowledgement.model';
import { TaskDescriptionAcknowledgementDTO } from '../dtos/project-tasks/task-description-acknowledgement.dto';
import { AbstractFactory } from './abstract.factory';

@Injectable({ providedIn: 'root' })
export class TaskDescriptionAcknowledgementFactory extends AbstractFactory<
  TaskDescriptionAcknowledgementDTO,
  TaskDescriptionAcknowledgement | undefined
> {
  public produce(item: TaskDescriptionAcknowledgementDTO): TaskDescriptionAcknowledgement | undefined {
    if (!item) {
      return undefined;
    }

    return new TaskDescriptionAcknowledgement({
      id: item.id,
      projectTaskDescriptionId: item.projectTaskDescriptionId,
      createdAt: new Date(item.createdAt),
      createdById: item.createdById,
      updatedAt: item.updatedAt ? new Date(item.updatedAt) : undefined,
      userId: item.userId,
      acceptedAt: item.acceptedAt ? new Date(item.acceptedAt) : undefined
    });
  }
}
